import {
  Button,
  Descriptions,
  Input,
  Popconfirm,
  Space,
  notification,
} from "antd";
import { deleteField } from "firebase/firestore";
import { observer } from "mobx-react-lite";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Employee, InvitationData } from "../../store";

const styles = {
  input: {
    width: "100%",
  },
  content: {
    width: "100%",
  },
  right: {
    float: "right" as const,
  },
};

interface Props {
  employee: Employee;
  onCancel?: () => void;
  onSave?: () => void;
  onRevoke?: () => void;
}

const EmployeeDetail = (props: Props) => {
  const { employee, onCancel, onSave, onRevoke } = props;
  const { name, invitation } = employee;

  const [data, setData] = useState<InvitationData | undefined>(
    invitation?.data
  );

  useEffect(() => {
    setData(invitation?.data);
  }, [invitation?.data]);

  const { phone, code } = data || {};

  const { t } = useTranslation();

  const update = (key: string) => (value: any) => {
    const newData = { ...data, [key]: value };
    setData(newData as InvitationData);
    return newData;
  };

  const save = async () => {
    try {
      await invitation?.update({ phone: data?.phone || deleteField() });
      notification.success({
        message: t("Updated user successfully"),
      });
    } catch (error) {
      const message = (error as Error)?.message;
      notification.error({
        message: t("Update invitation failed"),
        description: message,
      });
    }

    onSave?.();
  };

  const updateInput = (key: string) => (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    update(key)(value);
  };

  return (
    <Space direction="vertical" style={styles.content}>
      <Descriptions column={1} bordered>
        <Descriptions.Item label={t("Name")}>
          <Input value={name} style={styles.input} disabled />
        </Descriptions.Item>

        <Descriptions.Item label={t("Invitation code")}>
          <Input value={code} style={styles.input} disabled />
        </Descriptions.Item>

        <Descriptions.Item label={t("Phone")}>
          <Input
            value={phone}
            style={styles.input}
            onChange={updateInput("phone")}
          />
        </Descriptions.Item>
      </Descriptions>
      <div style={styles.content}>
        <Popconfirm
          title={t(
            "This operation will revoke the rights of this user and cannot be reversed. Are you sure you want to revoke this user?"
          )}
          okText={t("Revoke")}
          okButtonProps={{ danger: true }}
          onConfirm={onRevoke}
          cancelText={t("Cancel")}
        >
          <Button danger>{t("Revoke")}</Button>
        </Popconfirm>
        <Space style={styles.right}>
          <Button onClick={onCancel}>{t("Cancel")}</Button>
          <Button type="primary" onClick={save}>
            {t("Save")}
          </Button>
        </Space>
      </div>
    </Space>
  );
};

export default observer(EmployeeDetail);
